import { StatusPill } from '@/components/runs/StatusPill';
import { billingStatus } from '@/lib/billingStatus';

/** An organization's plan and its subscription status as a pill, for table rows. */
export function BillingCell({ productName, status }: { productName?: string; status?: string }) {
  if (!productName && !status) return <span className="text-muted-foreground">—</span>;
  const { label, tone } = billingStatus(status);
  return (
    <div className="flex flex-wrap items-center gap-1.5">
      {productName ? <span>{productName}</span> : null}
      {status ? <StatusPill tone={tone}>{label}</StatusPill> : null}
    </div>
  );
}
